import React, { useState } from 'react';
import './CahierDesCharges.css';
import { PRODUCTS } from './cahierData';

// ===== Rendu d'un bloc de script d'appel =====
function ScriptBlocks({ blocks }) {
  return (
    <>
      {blocks.map((b, i) => {
        if (b.s === 'STEP') return (
          <div key={i} style={{ background: '#0f2a43', color: '#fff', borderRadius: '8px', padding: '10px 14px', margin: '18px 0 8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '6px' }}>
            <span style={{ fontWeight: 600 }}><b style={{ background: 'rgba(255,255,255,.18)', borderRadius: '6px', padding: '2px 8px', marginRight: '10px' }}>{b.n}</b>{b.t}</span>
            {b.time && <small style={{ opacity: .8 }}>{b.time}</small>}
          </div>
        );
        if (b.s === 'SUB') return <div key={i} style={{ fontSize: '12px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '.5px', margin: '16px 0 4px' }}>{b.t}</div>;
        if (b.s === 'OPT') return (
          <div key={i} style={{ margin: '8px 0' }}>
            <div style={{ fontSize: '12px', fontWeight: 700, color: '#0f766e', marginBottom: '4px' }}>{b.l}</div>
            <div style={{ background: '#e8f6f4', borderLeft: '3px solid #14b8a6', borderRadius: '6px', padding: '10px 12px', color: '#1f2937', fontSize: '14px', lineHeight: 1.5 }}>{b.q}</div>
          </div>
        );
        if (b.s === 'VAL' || b.s === 'QUOTE') return <div key={i} style={{ background: '#e8f6f4', borderRadius: '6px', padding: '10px 12px', color: '#1f2937', fontSize: '14px', lineHeight: 1.5, margin: '8px 0' }}>{b.q}</div>;
        if (b.s === 'NOTE') return <div key={i} style={{ background: '#f1f5f9', borderLeft: '3px solid #64748b', borderRadius: '6px', padding: '10px 12px', color: '#475569', fontSize: '13px', lineHeight: 1.5, margin: '8px 0' }}>{b.t}</div>;
        if (b.s === 'QUALIF') return (
          <div key={i} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(190px,1fr))', gap: '10px', margin: '8px 0' }}>
            {b.cols.map((c, j) => (
              <div key={j} style={{ border: '1px solid #e2e8f0', borderRadius: '8px', padding: '11px' }}>
                <div style={{ fontWeight: 700, color: '#1f2937', marginBottom: '6px', fontSize: '14px' }}>{c.h}</div>
                <div style={{ fontSize: '13px', color: '#475569', lineHeight: 1.45 }}>{c.body}</div>
                {c.ok && <div style={{ fontSize: '12px', color: '#059669', marginTop: '6px', fontWeight: 600 }}>{c.ok}</div>}
                {c.stop && <div style={{ fontSize: '12px', color: '#dc2626', fontWeight: 600 }}>{c.stop}</div>}
              </div>
            ))}
          </div>
        );
        if (b.s === 'HIST') return (
          <div key={i} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(170px,1fr))', gap: '10px', margin: '8px 0' }}>
            {b.cols.map((c, j) => {
              const bg = c.tone === 'green' ? '#ecfdf5' : c.tone === 'red' ? '#fef2f2' : '#fffbeb';
              const bd = c.tone === 'green' ? '#6ee7b7' : c.tone === 'red' ? '#fca5a5' : '#fcd34d';
              const tx = c.tone === 'green' ? '#065f46' : c.tone === 'red' ? '#b91c1c' : '#92400e';
              return (
                <div key={j} style={{ background: bg, border: `1px solid ${bd}`, borderRadius: '8px', padding: '11px' }}>
                  <div style={{ fontWeight: 700, fontSize: '13px', color: '#1f2937', marginBottom: '4px' }}>{c.h}</div>
                  <div style={{ fontSize: '13px', color: tx, fontWeight: 600 }}>{c.v}</div>
                </div>
              );
            })}
          </div>
        );
        if (b.s === 'OBJ') return (
          <table key={i} style={{ width: '100%', borderCollapse: 'collapse', margin: '8px 0', fontSize: '14px' }}>
            <tbody>{b.rows.map((r, j) => (
              <tr key={j}>
                <td style={{ padding: '9px 10px', borderBottom: '1px solid #eef2f7', fontWeight: 600, color: '#1f2937', width: '38%', verticalAlign: 'top' }}>{r.o}</td>
                <td style={{ padding: '9px 10px', borderBottom: '1px solid #eef2f7', color: '#475569', lineHeight: 1.45 }}>{r.r}</td>
              </tr>
            ))}</tbody>
          </table>
        );
        if (b.s === 'GOSTOP') return (
          <div key={i} style={{ margin: '12px 0', overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
              <thead><tr>
                <th style={{ textAlign: 'left', padding: '8px 10px', background: '#f0fdfa', color: '#0f766e' }}>Critère</th>
                <th style={{ textAlign: 'left', padding: '8px 10px', background: '#f0fdfa', color: '#059669' }}>GO</th>
                <th style={{ textAlign: 'left', padding: '8px 10px', background: '#f0fdfa', color: '#dc2626' }}>STOP</th>
              </tr></thead>
              <tbody>{b.rows.map((r, j) => (
                <tr key={j}>
                  <td style={{ padding: '8px 10px', borderBottom: '1px solid #eef2f7', color: '#64748b' }}>{r.c}</td>
                  <td style={{ padding: '8px 10px', borderBottom: '1px solid #eef2f7', color: '#047857', fontWeight: 600 }}>{r.go}</td>
                  <td style={{ padding: '8px 10px', borderBottom: '1px solid #eef2f7', color: '#b91c1c', fontWeight: 600 }}>{r.stop}</td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        );
        return null;
      })}
    </>
  );
}

function CahierDesChargesCEE() {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [accessCode, setAccessCode] = useState('');
  const [codeError, setCodeError] = useState(false);
  const [productKey, setProductKey] = useState(null);

  const ACCESS_CODE = '2626';

  const handleCodeSubmit = (e) => {
    e.preventDefault();
    if (accessCode.trim().toUpperCase() === ACCESS_CODE) { setIsUnlocked(true); setCodeError(false); }
    else setCodeError(true);
  };

  const currentDate = new Date().toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

  const icons = {
    target: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>),
    check: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>),
    clipboard: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/></svg>),
    building: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01M16 6h.01M12 6h.01M12 10h.01M12 14h.01M16 10h.01M16 14h.01M8 10h.01M8 14h.01"/></svg>),
    phone: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/></svg>),
    rocket: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></svg>),
    medical: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 2a2 2 0 0 0-2 2v5H4a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h5v5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-5h5a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-5V4a2 2 0 0 0-2-2z"/></svg>),
    flow: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12h4l3-9 4 18 3-9h4"/></svg>),
    headphones: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/></svg>)
  };

  // ===== 1) Déverrouillage =====
  if (!isUnlocked) {
    return (
      <div className="cahier-des-charges-public">
        <div className="cahier-lock-screen">
          <div className="lock-card">
            <div className="lock-icon-container">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lock-svg"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            </div>
            <img src="/logo-eshops-pro.png" alt="E-Shops PRO" style={{ height: '54px', width: 'auto', objectFit: 'contain', marginBottom: '8px' }} />
            <h2 className="lock-title">Document Confidentiel</h2>
            <p className="lock-subtitle">Veuillez entrer le code d'acces pour consulter le Cahier des Charges</p>
            <form onSubmit={handleCodeSubmit} className="lock-form">
              <input type="text" value={accessCode} onChange={(e) => { setAccessCode(e.target.value); setCodeError(false); }} placeholder="Code d'acces" className={`lock-input ${codeError ? 'lock-input-error' : ''}`} autoFocus autoComplete="off" />
              {codeError && <p className="lock-error-msg">Code incorrect. Veuillez reessayer.</p>}
              <button type="submit" className="lock-btn">Acceder au document</button>
            </form>
            <p className="lock-hint">Contactez votre responsable si vous n'avez pas le code.</p>
          </div>
        </div>
      </div>
    );
  }

  // ===== 2) Choix du produit =====
  if (!productKey) {
    const card = (key, icon, color, title, sub) => (
      <button onClick={() => setProductKey(key)} style={{ flex: '1 1 200px', cursor: 'pointer', background: '#fff', border: `2px solid ${color}`, borderRadius: '16px', padding: '22px 16px', textAlign: 'center', boxShadow: '0 4px 14px rgba(0,0,0,.06)' }}>
        <div style={{ width: '54px', height: '54px', margin: '0 auto 12px', color, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{icon}</div>
        <h3 style={{ margin: '0 0 6px', color: '#1f2937', fontSize: '17px' }}>{title}</h3>
        <p style={{ margin: 0, color: '#6b7280', fontSize: '12.5px', lineHeight: 1.4 }}>{sub}</p>
      </button>
    );
    return (
      <div className="cahier-des-charges-public">
        <div className="cahier-lock-screen">
          <div className="lock-card" style={{ maxWidth: '780px' }}>
            <img src="/logo-eshops-pro.png" alt="E-Shops PRO" style={{ height: '52px', width: 'auto', objectFit: 'contain', marginBottom: '10px' }} />
            <h2 className="lock-title">Quel cahier des charges ?</h2>
            <p className="lock-subtitle">Choisissez le produit pour afficher le bon cahier des charges</p>
            <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', marginTop: '14px' }}>
              {card('destrat', icons.rocket, '#4f46e5', "Déstratification d'air", 'IND-BA-110 (industriel) · BAT-TH-142 (tertiaire)')}
              {card('iso', icons.medical, '#10b981', 'Isolation médicale', 'Combles (101) & Vide sanitaire (103) — EHPAD & santé')}
              {card('equilibrage', icons.flow, '#0ea5e9', 'Équilibrage des vannes', 'BAT-SE-103 — chauffage collectif tertiaire')}
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ===== 3) Contenu du produit =====
  const p = PRODUCTS[productKey];
  const heroIcon = productKey === 'iso' ? icons.medical : productKey === 'equilibrage' ? icons.flow : icons.rocket;

  return (
    <div className="cahier-des-charges-public">
      <div className="cahier-des-charges">
        <div className="cahier-header">
          <button onClick={() => setProductKey(null)} style={{ position: 'absolute', top: '16px', left: '16px', background: 'rgba(255,255,255,.18)', color: '#fff', border: '1px solid rgba(255,255,255,.4)', borderRadius: '8px', padding: '7px 12px', cursor: 'pointer', fontSize: '13px', fontWeight: 600 }}>← Changer de produit</button>
          <div className="header-badge">Document Officiel</div>
          <div className="cahier-title-section">
            <div className="logo-container"><img src="/logo-eshops-pro.png" alt="E-Shops PRO" style={{ height: '64px', width: 'auto', objectFit: 'contain' }} /></div>
            <h1>Cahier des Charges</h1>
            <p className="cahier-subtitle">{p.subtitle}</p>
          </div>
          <p className="cahier-date">Mis à jour le {currentDate}</p>
        </div>

        <div className="hero-illustration">
          <div className="hero-content">
            <div className="hero-icon-svg">{heroIcon}</div>
            <h2>Devis signés conformes</h2>
            <p>{p.heroSub}</p>
          </div>
          <div className="hero-devices">
            <div className="mini-laptop"><div className="mini-screen"></div><div className="mini-base"></div></div>
            <div className="mini-phone"><div className="mini-phone-screen"></div></div>
          </div>
        </div>

        <div className="cahier-content">
          {/* Objectif */}
          <section className="cahier-section">
            <div className="section-header"><span className="section-icon-svg">{icons.target}</span><h2>Objectif</h2></div>
            <div className="section-content"><p>{p.objectif}</p></div>
          </section>

          {/* Opérations */}
          <section className="cahier-section">
            <div className="section-header"><span className="section-icon-svg">{icons.clipboard}</span><h2>Opérations CEE concernées</h2></div>
            <div className="section-content">
              <ul className="criteria-list">
                {p.operations.map((op, i) => (
                  <li key={i}><span className="check-icon-svg">{icons.check}</span><span className="criteria-text"><strong>{op.code}</strong> — {op.label}</span></li>
                ))}
              </ul>
            </div>
          </section>

          {/* Cibles / secteurs */}
          <section className="cahier-section highlight-section">
            <div className="section-header"><span className="section-icon-svg">{icons.building}</span><h2>Établissements / secteurs à viser</h2></div>
            <div className="section-content">
              <p className="section-intro">{p.cibles.intro}</p>
              <div className="validation-grid">
                {p.cibles.items.map((it, i) => (
                  <div key={i} className="validation-item valid"><span className="validation-icon-svg">{icons.check}</span><span>{it}</span></div>
                ))}
              </div>
            </div>
          </section>

          {/* Critères */}
          <section className="cahier-section">
            <div className="section-header"><span className="section-icon-svg">{icons.check}</span><h2>Critères d'éligibilité</h2></div>
            <div className="section-content">
              <div className="validation-grid">
                {p.criteres.map((c, i) => (
                  <div key={i} className="validation-item valid"><span className="validation-icon-svg">{icons.check}</span><span>{c}</span></div>
                ))}
              </div>
            </div>
          </section>

          {/* Écoutes (enregistrements d'appels) */}
          {p.ecoutes && p.ecoutes.length > 0 && (
            <section className="cahier-section">
              <div className="section-header"><span className="section-icon-svg">{icons.headphones}</span><h2>Écoutes — enregistrements d'appels réels</h2></div>
              <div className="section-content">
                <p className="section-intro">Écoutez directement des appels de déstratification pour vous former au discours, au barrage secrétaire et au closing.</p>
                <div style={{ display: 'grid', gap: '12px' }}>
                  {p.ecoutes.map((e, i) => (
                    <div key={i} style={{ background: '#f7f7fb', border: '1px solid #e3e3ef', borderRadius: '10px', padding: '12px 14px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px', flexWrap: 'wrap', gap: '6px' }}>
                        <strong style={{ color: '#1f2937', fontSize: '14px' }}>🎧 {e.label}</strong>
                        <span style={{ fontSize: '12px', color: '#6b7280' }}>{e.dur}</span>
                      </div>
                      <audio controls preload="none" style={{ width: '100%' }} src={e.src}>
                        Votre navigateur ne supporte pas la lecture audio.
                      </audio>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          )}

          {/* Script d'appel */}
          <section className="cahier-section">
            <div className="section-header"><span className="section-icon-svg">{icons.phone}</span><h2>Script d'appel</h2></div>
            <div className="section-content">
              {p.scripts ? p.scripts.map((sc, i) => (
                <div key={i} style={{ marginBottom: '24px' }}>
                  <div style={{ background: 'linear-gradient(135deg,#0f2a43,#143b5e)', color: '#fff', borderRadius: '10px', padding: '14px 16px', marginBottom: '10px' }}>
                    <div style={{ fontWeight: 700, fontSize: '16px' }}>{sc.title}</div>
                    {sc.sub && <div style={{ fontSize: '12.5px', opacity: .85, marginTop: '3px' }}>{sc.sub}</div>}
                  </div>
                  <ScriptBlocks blocks={sc.blocks} />
                </div>
              )) : (
                <div style={{ background: '#fffbeb', border: '1px solid #fcd34d', borderRadius: '8px', padding: '14px', color: '#92400e', fontSize: '14px' }}>
                  {p.scriptNote}
                </div>
              )}
            </div>
          </section>
        </div>

        <div className="cahier-footer">
          <div className="footer-logo">E-Shop Pro</div>
          <p>Document officiel — {currentDate}</p>
          <p className="footer-tagline">Votre partenaire CEE de confiance</p>
        </div>
      </div>
    </div>
  );
}

export default CahierDesChargesCEE;
